'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BasicInput = exports.Input = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

var _Input = require('./Input.style');

var _FieldWrapper = require('../FieldWrapper/FieldWrapper');

var _FieldWrapper2 = _interopRequireDefault(_FieldWrapper);

var _helpers = require('../helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Basic form input. All other props passed to this component will be
 * passed through to the actual input field.
 */
var Input = function Input(_ref) {
  var className = _ref.className,
      description = _ref.description,
      error = _ref.error,
      focused = _ref.focused,
      label = _ref.label,
      name = _ref.name,
      wrapperProps = _ref.wrapperProps,
      rest = (0, _objectWithoutProperties3.default)(_ref, ['className', 'description', 'error', 'focused', 'label', 'name', 'wrapperProps']);
  return _react2.default.createElement(
    _FieldWrapper2.default,
    {
      description: description,
      error: error,
      label: label,
      labelFor: name,
      wrapperProps: wrapperProps
    },
    _react2.default.createElement(
      'div',
      { className: 'input ' + className },
      _react2.default.createElement('input', (0, _extends3.default)({}, rest, {
        id: name,
        name: name
      }))
    )
  );
};

exports.Input = Input;
Input.propTypes = {
  /**
   * className for glamorous styles
   */
  className: _propTypes2.default.string.isRequired,
  /**
   * Helper description for tooltip
   */
  description: _propTypes2.default.string,
  /**
   * Error message for input. Alters input style and displays error message if set.
   */
  error: _propTypes2.default.string,
  /**
   * Field label text to display above input
   */
  label: _propTypes2.default.string,
  /**
   * Field name in form
   */
  name: _propTypes2.default.string,
  /**
   * Function to call on input blur
   */
  onBlur: _propTypes2.default.func,
  /**
   * Function to call on input change
   */
  onChange: _propTypes2.default.func,
  /**
   * Function to call on input focus
   */
  onFocus: _propTypes2.default.func,
  /**
   * Placeholder text for input
   */
  placeholder: _propTypes2.default.string,
  /**
   * Input type
   */
  type: _propTypes2.default.string,
  /**
   * Props to pass on to the Input Component Wrapper.
   */
  wrapperProps: _propTypes2.default.object,
  /**
   * Input value
   */
  value: _propTypes2.default.string
};
Input.defaultProps = {
  type: 'text'
};

var BasicInput = exports.BasicInput = (0, _glamorous2.default)(Input)(_Input.defaultStyle, _Input.mapPropsAndThemeToStyle);

exports.default = (0, _helpers.withFocus)((0, _glamorous2.default)(Input)(_Input.defaultStyle, _Input.mapPropsAndThemeToStyle));


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/form/Input/Input.js
// module id = 118
// module chunks = 0